import {
    MDBBtn,
    MDBCol,
    MDBContainer,
    MDBRow,
    MDBSwitch,
} from "mdb-react-ui-kit";
import {
    forwardRef,
    ReactElement,
    useCallback,
    useEffect,
    useMemo,
    useState,
} from "react";
import TagsPackageType from "@/components/detail/tags/TagsPackageType";
import { useIsSM } from "@/utils/hooks/useWindowSizes";
import { DestinationReadableTO } from "../../../models/detail";
import styles from "../../../styles/detail/DetailAccomodations.module.scss";
import {
    accomodationsTitle,
    accomodationSubTitle,
} from "../../../utils/mockData/detailMocks";
import { qualityPremiumContent } from "../../../utils/mockData/infoMock";
import contactsSvg from "../../../utils/svg-icon/contacts";
import InfoModalDouble from "../../common/info/InfoModalDouble";
import SectionTitle from "../../common/SectionTitle";
import PackageDetailHotelCard from "../PackageDetailHotelCard";
import PackageDetailHotelGallery from "../PackageDetailHotelGallery";
import OvernightCarousel from "./OvernightCarousel";
import useForwardRef from "../../../utils/hooks/useForwardRef";
import { useStore } from "../../../store";
import useOnScreen from "../../../utils/hooks/useOnScreen";
import { EDetailSection, ETypePackage } from "../../../models/common/enums";

const OvernightAccommodations = forwardRef<
    HTMLDivElement,
    {
        nightDestinations: DestinationReadableTO[];
        isPremium: boolean;
        setIsPremium: (el: boolean) => void;
        typePackage: ETypePackage;
        showAccomodations: boolean;
    }
>(
    (
        {
            nightDestinations,
            isPremium,
            setIsPremium,
            typePackage,
            showAccomodations,
        },
        ref
        // eslint-disable-next-line sonarjs/cognitive-complexity
    ): ReactElement => {
        const overNightRef = useForwardRef<HTMLInputElement>(ref);
        const dispatch = useStore(state => state.dispatchPackage);

        const { InfoCircleLine } = contactsSvg;
        const cityAccommodations = useMemo(
            () =>
                nightDestinations
                    .filter(
                        nightDestination =>
                            nightDestination.showHotel &&
                            (isPremium
                                ? nightDestination.premiumHotelsPresent
                                : nightDestination.qualityHotelsPresent)
                    )
                    .map(el => el.city),
            [isPremium, nightDestinations]
        );
        const [showModal, setShowModal] = useState<boolean>(false);
        const [showInfoModal, setShowInfoModal] = useState<boolean>(false);
        const [resetCarousel, setResetCarousel] = useState<boolean>(false);
        const [selectedCity, setSelectedCity] = useState<string>(
            cityAccommodations[0]
        );
        const [selectedHotel, setSelectedHotel] = useState<number>(0);

        const filterAccommodations = useMemo(
            () =>
                nightDestinations
                    .filter(el => el.showHotel)
                    .find(el => el.city === selectedCity)
                    ?.hotels?.filter(
                        value =>
                            value?.option ===
                            (isPremium ? "PREMIUM" : "QUALITY")
                    ) ?? [],
            [nightDestinations, selectedCity, isPremium]
        );

        const isOnScreen = useOnScreen(overNightRef);

        const hotelGalleryHandler = (selectedIndex: number) => {
            setSelectedHotel(selectedIndex);
            setShowModal(true);
        };

        const handleTabClick = (el: string) => {
            setResetCarousel(true);
            setSelectedCity(el);
        };

        const getVisibleCards = useCallback(() => {
            return filterAccommodations.map((el, idx) => (
                /* eslint-disable react/no-array-index-key */
                <PackageDetailHotelCard
                    key={`${idx}_${el.name}`}
                    packageAccommodation={el}
                    currentIndex={idx}
                    hotelGalleryHandler={hotelGalleryHandler}
                    isPremium={isPremium}
                />
            ));
        }, [selectedCity, isPremium]);
        useEffect(() => {
            if (isOnScreen) {
                dispatch({
                    type: "SET_CURRENT_SECTION",
                    payload: EDetailSection.ACCOMMODATION,
                });
            }
        }, [isOnScreen]);

        const isSM = useIsSM();

        return showAccomodations ? (
            <div className={styles.customContainer} ref={overNightRef}>
                <div className={styles.accomodationContainer}>
                    {isSM &&
                        typePackage === ETypePackage.QUALITY_AND_PREMIUM && (
                            <>
                                {/* <div className="justify-content-center">
                                    <div
                                        className={styles.info}
                                        role="button"
                                        tabIndex={0}
                                        onClick={() => setShowInfoModal(true)}
                                    >
                                        <p>Choose your esperienza</p>
                                        <InfoCircleLine />
                                    </div>
                                </div> */}
                                <div className="justify-content-center mt-3">
                                    <div className="d-flex justify-content-center mt-1 mb-2">
                                        <span
                                            className={
                                                !isPremium
                                                    ? `pe-2 ${styles.cardSecondaryTextBold}`
                                                    : `pe-2 ${styles.cardSecondaryText}`
                                            }
                                        >
                                            Quality
                                        </span>
                                        <MDBSwitch
                                            checked={isPremium}
                                            onChange={() => {
                                                setIsPremium(!isPremium);
                                                // const url = new URL(
                                                //     window.location.href
                                                // );
                                                // url.searchParams.set(
                                                //     "isPremium",
                                                //     !isPremium as unknown as string
                                                // );
                                                // window.history.replaceState(
                                                //     null,
                                                //     "",
                                                //     url
                                                // );
                                            }}
                                            className={styles.customSwitch}
                                        />
                                        <span
                                            className={
                                                isPremium
                                                    ? `ps-3 ${styles.cardSecondaryTextBold}`
                                                    : `ps-3 ${styles.cardSecondaryText}`
                                            }
                                        >
                                            Premium
                                        </span>
                                    </div>
                                    <div className="justify-content-center">
                                        <div
                                            className={styles.info}
                                            role="button"
                                            tabIndex={0}
                                            onClick={() =>
                                                setShowInfoModal(true)
                                            }
                                        >
                                            <InfoCircleLine />
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}

                    {isSM &&
                        typePackage !== ETypePackage.QUALITY_AND_PREMIUM && (
                            <TagsPackageType
                                isPremium={
                                    typePackage === ETypePackage.ONLY_PREMIUM
                                }
                            />
                        )}

                    <div>
                        <SectionTitle
                            sectionTitle={{
                                title: accomodationsTitle,
                                subTitle: accomodationSubTitle,
                                classNameContainer: "p-0 m-0",
                                alignment: "justify-content-center text-center",
                                titleColumnSize: 6,
                                classNameTitle: styles.titleAccodomodations,
                                classNameSubTitle:
                                    styles.subtitleAccodomodations,
                            }}
                        />
                    </div>
                    {!isSM &&
                        typePackage === ETypePackage.QUALITY_AND_PREMIUM && (
                            <>
                                {/* <div className="justify-content-center">
                                    <div
                                        className={styles.info}
                                        role="button"
                                        tabIndex={0}
                                        onClick={() => setShowInfoModal(true)}
                                    >
                                        <p>Choose your esperienza</p>
                                        <InfoCircleLine />
                                    </div>
                                </div> */}
                                <div className="justify-content-center mt-3">
                                    <div className="d-flex justify-content-center mt-1 mb-2">
                                        <span
                                            className={
                                                !isPremium
                                                    ? `pe-2 ${styles.cardSecondaryTextBold}`
                                                    : `pe-2 ${styles.cardSecondaryText}`
                                            }
                                        >
                                            Quality
                                        </span>
                                        <MDBSwitch
                                            checked={isPremium}
                                            onChange={() => {
                                                setIsPremium(!isPremium);
                                                // const url = new URL(
                                                //     window.location.href
                                                // );
                                                // url.searchParams.set(
                                                //     "isPremium",
                                                //     !isPremium as unknown as string
                                                // );
                                                // window.history.replaceState(
                                                //     null,
                                                //     "",
                                                //     url
                                                // );
                                            }}
                                            className={styles.customSwitch}
                                        />
                                        <span
                                            className={
                                                isPremium
                                                    ? `ps-3 ${styles.cardSecondaryTextBold}`
                                                    : `ps-3 ${styles.cardSecondaryText}`
                                            }
                                        >
                                            Premium
                                        </span>
                                    </div>
                                    <div className="justify-content-center">
                                        <div
                                            className={styles.info}
                                            role="button"
                                            tabIndex={0}
                                            onClick={() =>
                                                setShowInfoModal(true)
                                            }
                                        >
                                            <InfoCircleLine />
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}

                    {!isSM &&
                        typePackage !== ETypePackage.QUALITY_AND_PREMIUM && (
                            <TagsPackageType
                                isPremium={
                                    typePackage === ETypePackage.ONLY_PREMIUM
                                }
                            />
                        )}
                    <MDBRow className="d-flex justify-content-center p-md-0">
                        <div
                            className={`d-flex justify-content-md-center ms-4 mx-md-5 ${styles.carousel}`}
                        >
                            {cityAccommodations.map((el, index) => (
                                <MDBCol md={2} lg={1} size={4} className="mx-2">
                                    <MDBBtn
                                        key={`${index}_${el}`}
                                        onClick={() => handleTabClick(el)}
                                        className={
                                            selectedCity === el
                                                ? styles.cityButtonSelected
                                                : styles.cityButton
                                        }
                                    >
                                        <p>{el}</p>
                                    </MDBBtn>
                                </MDBCol>
                            ))}
                        </div>
                    </MDBRow>
                    <MDBContainer fluid className="p-0">
                        <OvernightCarousel
                            visibleCards={getVisibleCards()}
                            resetCarousel={resetCarousel}
                            setResetCarousel={setResetCarousel}
                        />
                    </MDBContainer>
                </div>
                <PackageDetailHotelGallery
                    show={showModal}
                    setShow={setShowModal}
                    currentHotel={filterAccommodations.at(selectedHotel)!}
                />
                <InfoModalDouble
                    content={qualityPremiumContent}
                    show={showInfoModal}
                    setShow={setShowInfoModal}
                />
            </div>
        ) : (
            <div ref={overNightRef} />
        );
    }
);

export default OvernightAccommodations;
